import { StoreModelType, TableResourceType } from '@smx-ui-model/types';
import { Divider, Flex } from 'antd';
import * as React from 'react';
import { memo, useContext } from 'react';

import FormInspector from './form-inspector';
import HeaderInspector from './header-inspector';
import { SmxInspectorContext } from './inspector-provider';
import { SimpleDrawer } from './simple-drawer';

interface InspectorProps {
    modelName: keyof StoreModelType;
    entity?: TableResourceType;
    offsetRight: number;
}

const Inspector: React.FC<InspectorProps> = ({ modelName, entity, offsetRight }) => {
    const { isOpen } = useContext(SmxInspectorContext);

    return (
        <SimpleDrawer open={!!isOpen} offsetRight={offsetRight}>
            <Flex vertical>
                <HeaderInspector entity={entity} modelName={modelName} />
                <Divider style={{ margin: '5px 0' }} />
            </Flex>
            <Flex vertical flex={1} style={{ minHeight: 0 }}>
                <FormInspector entity={entity} modelName={modelName} />
            </Flex>
        </SimpleDrawer>
    );
};

export default memo(Inspector);
